import React from "react";
import { TablePagination, Typography, makeStyles } from "@material-ui/core";
import TablePaginationActions from "widgets/Tables/Pagination";

const useStyles = makeStyles((theme) => ({
  panel: {
    background: "#111a2b",
    border: "1px solid #1d3454",
    borderRadius: 8,
    overflow: "hidden",
  },
  panelTitle: {
    color: "#f5f7fb",
    fontSize: 17,
    fontWeight: 900,
    padding: theme.spacing(2, 2.5),
  },
  tableWrapper: {
    overflowX: "auto",
  },
  table: {
    borderCollapse: "collapse",
    minWidth: 980,
    width: "100%",
  },
  tableHead: {
    background: "#1a253b",
  },
  headerCell: {
    color: "#53647e",
    fontSize: 11,
    fontWeight: 900,
    letterSpacing: 1,
    padding: theme.spacing(1.35, 2),
    textAlign: "left",
    textTransform: "uppercase",
  },
  bodyRow: {
    borderTop: "1px solid #1d3454",
  },
  bodyCell: {
    color: "#acd0f6",
    fontSize: 13,
    padding: theme.spacing(1.7, 2),
  },
  strongCell: {
    color: "#bcd8f8",
    fontSize: 13,
    fontWeight: 900,
    padding: theme.spacing(1.7, 2),
  },
  statusBadge: {
    background: "#075958",
    borderRadius: 14,
    color: "#22f0c2",
    display: "inline-block",
    fontSize: 12,
    fontWeight: 900,
    minWidth: 52,
    padding: "3px 10px",
    textAlign: "center",
  },
  inactiveStatus: {
    background: "transparent",
    color: "#8ba8cc",
    padding: 0,
  },
  statusText: {
    color: "#b8cdf0",
    fontSize: 13,
    padding: theme.spacing(0, 2.5, 2),
  },
  errorText: {
    color: "#ff8a9a",
    fontSize: 13,
    padding: theme.spacing(0, 2.5, 2),
  },
  pagination: {
    alignItems: "center",
    background: "#111a2b",
    borderTop: "1px solid #1d3454",
    color: "#acd0f6",
    display: "flex",
    justifyContent: "flex-end",
    minHeight: 52,
    "& .MuiTablePagination-toolbar": {
      minHeight: 52,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
    },
    "& .MuiTablePagination-caption": {
      color: "#acd0f6",
      fontSize: 12,
    },
    "& .MuiTablePagination-selectIcon": {
      color: "#acd0f6",
    },
    "& .MuiSelect-root": {
      color: "#f5f7fb",
      fontSize: 12,
    },
  },
}));

const formatDate = (date) => {
  if (!date) return "";

  return new Date(date).toLocaleDateString("es-EC");
};

const ClientesTable = ({
  error,
  loading,
  rows,
  totalElements,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.panel}>      
      {loading && (
        <Typography className={classes.statusText}>Cargando clientes...</Typography>
      )}
      {error && <Typography className={classes.errorText}>{error}</Typography>}
      <div className={classes.tableWrapper}>
        <table className={classes.table}>
          <thead className={classes.tableHead}>
            <tr>
              <th className={classes.headerCell}>RUC / CI</th>
              <th className={classes.headerCell}>Razon Social</th>
              <th className={classes.headerCell}>E-mail</th>
              <th className={classes.headerCell}>Telefono</th>
              <th className={classes.headerCell}>Direccion</th>
              <th className={classes.headerCell}>Fecha Registro</th>
              <th className={classes.headerCell}>Estado</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((client) => (
              <tr className={classes.bodyRow} key={client.id}>
                <td className={classes.bodyCell}>{client.ruc}</td>
                <td className={classes.strongCell}>{client.razonSocial}</td>
                <td className={classes.bodyCell}>{client.email}</td>
                <td className={classes.bodyCell}>{client.telefono}</td>
                <td className={classes.bodyCell}>{client.direccion}</td>
                <td className={classes.bodyCell}>
                  {formatDate(client.fechaRegistro)}
                </td>
                <td className={classes.bodyCell}>
                  <span
                    className={`${classes.statusBadge} ${
                      client.activo ? "" : classes.inactiveStatus
                    }`}
                  >
                    {client.activo ? "Activo" : "Inactivo"}
                  </span>
                </td>
              </tr>
            ))}
            {rows.length === 0 && !loading && (
              <tr className={classes.bodyRow}>
                <td className={classes.bodyCell} colSpan={7}>
                  No existen clientes para mostrar.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <TablePagination
        ActionsComponent={TablePaginationActions}
        className={classes.pagination}
        component="div"
        count={totalElements || 0}
        labelDisplayedRows={({ from, to, count }) =>
          count ? `${from}-${to} de ${count}` : "0 de 0"
        }
        labelRowsPerPage="Filas por página:"
        onChangePage={onPageChange}
        onChangeRowsPerPage={onRowsPerPageChange}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5, 10, 15, 25]}
      />
    </div>
  );
};

export default ClientesTable;
